import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home').then((m) => m.Home),
  },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.auth_routes),
  },
];
